// src/services/documentService.jsx
import axios from 'axios';
import { API_URL } from '../utils/apiConfig';
import { 
  invalidateDocumentQueries, 
  invalidateFolderQueries,
  optimisticallyUpdateDocumentStatus 
} from '../utils/queryClient';

const api = axios.create({
  baseURL: API_URL
});

// Helper function to get token
const getToken = () => {
  const storedUser = localStorage.getItem('user');
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      return user.token;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
    }
  }
  return null;
};

// Add auth token to all requests
api.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


//     }
//   },
  
//   // Restore a specific version
//   async restoreDocumentVersion(documentId, versionId) {
//     try {
//       const response = await api.post(`/documents/${documentId}/versions/${versionId}/restore`);
//       return response.data;
//     } catch (error) {
//       console.error('Error restoring version:', error);
//       throw error;
//     }
//   },
  
//   // Delete a document (only for document owners)
//   async deleteDocument(documentId) {
//     try {
//       const response = await api.delete(`/documents/${documentId}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error deleting document:', error);
//       throw error;
//     }
//   },
  
//   // Hide a document (works for both owners and recipients)
//   async hideDocument(documentId) {
//     try {
//       const response = await api.post(`/documents/${documentId}/hide`);
//       return response.data;
//     } catch (error) {
//       console.error('Error hiding document:', error);
//       throw error;
//     }
//   },
  
//   // Get document access permissions
//   async getDocumentPermissions(documentId) {
//     try {
//       const response = await api.get(`/documents/${documentId}/permissions`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching document permissions:', error);
//       throw error;
//     }
//   },
  
//   // Share document with a user
//   async shareDocument(documentId, email, permissions) {
//     try {
//       const response = await api.post(`/documents/${documentId}/permissions`, {
//         email,
//         permissions
//       });
//       return response.data;
//     } catch (error) {
//       console.error('Error sharing document:', error);
//       throw error;
//     }
//   },
  
//   // Revoke a user's permission
//   async revokePermission(documentId, userId, permission) {
//     try {
//       const response = await api.delete(`/documents/${documentId}/permissions/${userId}/${permission}`);
//       return response.data;
//     } catch (error) {
//       console.error('Error revoking permission:', error);
//       throw error;
//     }
//   },

//   // Get document view history
//   async getDocumentViews(documentId) {
//     try {
//       const response = await api.get(`/documents/${documentId}/views`);
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching document views:', error);
//       throw error;
//     }
//   },
  
//   // Record a document view
//   async recordDocumentView(documentId) {
//     try {
//       const response = await api.post(`/documents/${documentId}/view`);
//       return response.data;
//     } catch (error) {
//       console.error(`Error recording view for document ${documentId}:`, error);
//       // Don't throw error for view tracking to avoid breaking the app
//       return null;
//     }
//   }
// };

// // Share a document with other users
// export const shareDocument = async (documentId, emails, permissions) => {
//   try {
//     console.log(`Sharing document ${documentId} with ${emails.length} recipients:`, emails);
//     const response = await fetch(`${API_URL}/documents/${documentId}/share`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${getToken()}`
//       },
//       body: JSON.stringify({ emails, permissions })
//     });

//     if (!response.ok) {
//       const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
//       console.error(`Error sharing document (Status ${response.status}):`, errorData);
//       return { success: false, error: errorData.error || `Server returned ${response.status}` };
//     }

//     const data = await response.json();
//     console.log('Document shared successfully:', data);
//     return { success: true, data };
//   } catch (error) {
//     console.error('Exception when sharing document:', error);
//     return { success: false, error: error.message };
//   }
// };

export const documentService = {
  // Fetch documents with pagination, search and filtering support
  async getUserDocuments(page = 1, limit = 10, tab = 'uploaded', searchQuery = '', statusFilter = 'all', sortBy = 'createdAt', sortOrder = 'DESC', currentFolderId = null) {
    try {
      // Create query params
      const params = new URLSearchParams();
      if (page) params.append('page', page);
      if (limit) params.append('limit', limit);
      if (tab) params.append('tab', tab);
      if (searchQuery) params.append('search', searchQuery);
      if (statusFilter !== 'all') {
        const normalized = statusFilter === 'pending' ? 'pending_signature' : statusFilter;
        params.append('status', normalized);
      }
      if (sortBy) params.append('sortBy', sortBy);
      if (sortOrder) params.append('sortOrder', sortOrder);
      if (currentFolderId) params.append('currentFolderId', currentFolderId);
      const queryString = params.toString();
      const endpoint = queryString ? `/documents?${queryString}` : '/documents';
      
      // Debug logging - only in development
      if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG_API === 'true') {
        console.log('DocumentService - Making request to:', `${API_URL}${endpoint}`);
        console.log('DocumentService - Token:', getToken()?.substring(0, 50) + '...');
        
        // Log current user from localStorage
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          const user = JSON.parse(storedUser);
          console.log('DocumentService - Current user:', { id: user.id, email: user.email, name: user.name });
        }
      }
      
      const response = await api.get(endpoint);
      
      // Debug logging - only in development
      if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG_API === 'true') {
        console.log('DocumentService - Response received:', response.data);
        console.log('DocumentService - Number of documents:', response.data?.length || 0);
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching documents:', error);
      console.error('DocumentService - Error details:', {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message
      });
      throw error;
    }
  },

  // Get aggregate stats for documents (pending/completed/draft/total)
  async getDocumentStats(tab = 'uploaded', currentFolderId = null, searchQuery = '') {
    try {
      const params = new URLSearchParams();
      if (tab) params.append('tab', tab);
      if (currentFolderId !== undefined && currentFolderId !== null) params.append('currentFolderId', currentFolderId);
      if (searchQuery) params.append('search', searchQuery);
      const endpoint = `/documents/stats?${params.toString()}`;
      const response = await api.get(endpoint);
      return response.data; // { pendingCount, completedCount, draftCount, totalCount }
    } catch (error) {
      console.error('Error fetching document stats:', error);
      throw error;
    }
  },

  // Check if bulk endpoint is available - simplified version that always returns false
  async isBulkEndpointAvailable() {
    return false; // Always return false to use the fallback approach
  },

  // Bulk document details (placeholder that will never be called since isBulkEndpointAvailable returns false)
  async getBulkDocumentDetails(documentIds) {
    try {
      // This is just a placeholder - it won't be called in your current implementation
      const response = await api.post('/documents/bulk-details', { documentIds });
      return response.data;
    } catch (error) {
      console.error('Error fetching bulk document details:', error);
      throw error;
    }
  },

  // Get a single document by ID
  async getDocument(documentId, signatureToken = null) {
    try {
      const url = signatureToken 
        ? `/documents/${documentId}?token=${signatureToken}`
        : `/documents/${documentId}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching document:', error);
      throw error;
    }
  },

  // Get document file URL
  async getDocumentFileUrl(documentId, signatureToken = null) {
    try {
      const url = signatureToken 
        ? `/documents/${documentId}/file?token=${signatureToken}`
        : `/documents/${documentId}/file`;
        
      const response = await api.get(url, {
        responseType: 'blob'
      });
      const contentType = response.headers['content-type'] || 'application/pdf';
      const fileBlob = new Blob([response.data], { type: contentType });
      return URL.createObjectURL(fileBlob);
    } catch (error) {
      console.error('Error fetching document file:', error);
      throw error;
    }
  },

  // Get a public document by ID (no auth required)
  async getPublicDocument(documentId) {
    try {
      // Create a non-authenticated axios instance for public access
      const publicApi = axios.create({
        baseURL: API_URL
      });
      const response = await publicApi.get(`/documents/${documentId}/public`);
      return response.data;
    } catch (error) {
      console.error('Error fetching public document:', error);
      throw error;
    }
  },

  // Upload a new document with detailed logging
  async uploadDocument(file, metadata = {}, onUploadProgress = null) {
    console.log('📤 Starting uploadDocument with file:', file.name, file.type, file.size);
    console.log('📤 Metadata:', metadata);
    try {
      // Create a new FormData object
      const formData = new FormData();
      // Append the file with the key 'file'
      formData.append('file', file);
      console.log('📤 File appended to FormData');
      // Add metadata fields
      Object.keys(metadata).forEach(key => {
        formData.append(key, metadata[key]);
        console.log(`📤 Appended metadata: ${key}=${metadata[key]}`);
      });
      // Log the formData keys for debugging
      const formDataKeys = [];
      for (let key of formData.keys()) {
        formDataKeys.push(key);
      }
      console.log('📤 FormData contains keys:', formDataKeys);
      // Set up request config
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      };
      // Add progress tracking if provided
      if (onUploadProgress) {
        config.onUploadProgress = onUploadProgress;
        console.log('📤 Upload progress tracking enabled');
      }
      console.log('📤 Sending API request to:', `${API_URL}/documents/upload`);
      // Make the request
      const response = await api.post('/documents/upload', formData, config);
      console.log('📤 Upload successful, response:', response.data);
      
      // ✅ CACHE INVALIDATION: Invalidate documents and folders after successful upload
      invalidateDocumentQueries();
      invalidateFolderQueries();
      console.log('🔄 Cache invalidated after document upload');
      
      return response.data;
    } catch (error) {
      console.error('❌ Error in uploadDocument:', error);
      if (error.response) {
        console.error('❌ Response data:', error.response.data);
        console.error('❌ Response status:', error.response.status);
        console.error('❌ Response headers:', error.response.headers);
      } else if (error.request) {
        console.error('❌ No response received, request:', error.request);
      } else {
        console.error('❌ Error message:', error.message);
      }
      throw error;
    }
  },

  // Get version history for a document
  async getDocumentVersions(documentId) {
    try {
      const response = await api.get(`/documents/${documentId}/versions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching document versions:', error);
      throw error;
    }
  },

  // Get document views by document ID
  async getDocumentViews(documentId) {
    try {
      const response = await api.get(`/documents/${documentId}/views`);
      return response.data;
    } catch (error) {
      console.error('Error fetching document views:', error);
      throw error;
    }
  },

  // Update document content (creates a new version)
  async updateDocumentContent(documentId, content, comment = '') {
    try {
      const response = await api.post(`/documents/${documentId}/versions`, {
        content,
        comment
      });
      
      // ✅ CACHE INVALIDATION: Invalidate documents after content update
      invalidateDocumentQueries();
      console.log('🔄 Cache invalidated after document content update');
      
      return response.data;
    } catch (error) {
      console.error('❌ Error updating document:', error);
      throw error;
    }
  },

  // Get document permissions by document ID
  async getDocumentPermissions(documentId) {
    try {
      const response = await api.get(`/documents/${documentId}/permissions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching document permissions:', error);
      throw error;
    }
  },

  // Move a document to a different folder
  async moveDocument(documentId, folderId) {
    try {
      const payload = {
        folderId: folderId || null // Ensure null for root moves instead of undefined
      };
      
      const response = await api.post(`/folders/documents/${documentId}/move`, payload);
      
      // ✅ CACHE INVALIDATION: Invalidate documents and folders after moving
      invalidateDocumentQueries();
      invalidateFolderQueries();
      console.log('🔄 Cache invalidated after document move');
      
      return response.data;
    } catch (error) {
      console.error('❌ Error moving document:', error);
      throw error;
    }
  },

  // Hide a document (works for both owners and recipients)
  async hideDocument(documentId) {
    try {
      const response = await api.delete(`/documents/${documentId}`);
      
      // ✅ CACHE INVALIDATION: Invalidate documents after hiding/deleting
      invalidateDocumentQueries();
      console.log('🔄 Cache invalidated after document hide/delete');
      
      return response.data;
    } catch (error) {
      console.error('❌ Error hiding document:', error);
      throw error;
    }
  },

  // Get document audit trail
  async getDocumentAuditTrail(documentId) {
    try {
      const response = await api.get(`/documents/${documentId}/audit-trail`);
      return response.data;
    } catch (error) {
      console.error('Error fetching document audit trail:', error);
      throw error;
    }
  }
};